<section class="hero">
  <div class="amman">
    <img src="../assets/images/amman.png" alt="ok" />
  </div>

  <div class="hero-text">
    <h1>
      Devanga Sowdeshwari Amman <br />
      Association of North America
    </h1>
    <p>a non-profit organization</p>
  </div>

  <div class="gop">
    <img src="../assets/images/gop.png" alt="ok" />
  </div>
</section>

<style lang="scss">
  @font-face {
    font-family: "H1Font";
    src: url("../assets/fonts/vinque.ttf");
  }
  .hero {
    width: 100vw;
    height: 100vh;
    display: grid;
    grid-template-columns: 3fr 4fr 3fr;
    background-image: url("../assets/images/bg.jpg");

    div {
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        width: 70%;
      }

      h1 {
        font-family: "H1Font";
        text-align: center;
        color: rgb(37, 37, 37);
      }
    }

    .hero-text {
      flex-direction: column;

      p {
        background-color: #ff9933;
        padding: 5px 15px;
        border-radius: 5px;
        font-weight: bold;
        color: #fff;
      }
    }
  }
</style>
